export const environment = {
    production: false,
    showInDevelopmentFeatures: true,
    apiUrl: 'https://lemunzo-dev-container-epa7etc2ffh9h4fn.germanywestcentral-01.azurewebsites.net/api/',
    uploadWorkerUrl:
        'https://lemunzo-dev-upload-worker-g2gea8gvhnh2hhdk.germanywestcentral-01.azurewebsites.net/api/',
    clientPortalUrl: 'https://black-beach-003bf1c03.6.azurestaticapps.net/',
    authConfig: {
        // points to Staging External Entra ID => PROD uses Workforce Entra ID
        clientId: '23d65cca-1934-474a-a22b-5790760e6dcc',
        authority:
            'https://15f1d6bf-7430-4e0d-aef0-b7934c717d28.ciamlogin.com/15f1d6bf-7430-4e0d-aef0-b7934c717d28',
        apiConfig: {
            scopes: [
                'api://23d65cca-1934-474a-a22b-5790760e6dcc/Lemunzo.Admin.FE',
            ],
            uri: 'https://lemunzo-dev-container-epa7etc2ffh9h4fn.germanywestcentral-01.azurewebsites.net/api',
            unprotected: [
                '/cases/public',
                '/client-registrations/public',
                '/localization/public',
            ],
        },
    },
};
